<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-update-report">
		<dc-alert [variant]="'flat'" [type]="'error'" [message]="vo.message"></dc-alert>

		<ng-container *ngFor="let entry of vo.report | toArray">

<!--			<ng-container *ngIf="vo.report.size === 1">-->
<!--				<span>{{ entry.label }}</span>-->
<!--				<div *ngFor="let consumer of entry.consumedWithin" class="consumer-element">-->
<!--					&lt;!&ndash;					<a appNavigate [navigateTo]="consumer.elemUrl">{{consumer.label}}</a>&ndash;&gt;-->
<!--					<span>({{ consumer.type }})</span>-->
<!--				</div>-->
<!--			</ng-container>-->

			<div *ngIf="vo.report.size >= 1" class="consumer-elements-container" (click)="toggleReportFor(entry.uuid)">
				<span>{{ entry.label }}</span>
				<span class="consumer-element-more-less">
					<mat-icon *ngIf="!entry.isOpen">add</mat-icon>
					<mat-icon *ngIf="entry.isOpen">remove</mat-icon>
				</span>
			</div>
			<div *ngIf="entry.isOpen" class="report-details">
				<div *ngIf="entry.colTemplates.length !== 0" class="usage-block">
					<span class="using-item__label"
								i18n="@@general.subscription.columnModels">Column Models</span>
					<div *ngFor="let colTemplate of entry.colTemplates" class="consumer-element">
						<!--						<a appNavigate [navigateTo]="colTemplate.elemUrl">{{colTemplate.label}}</a>-->
						<span class="using-item">{{ colTemplate.label }}</span>
					</div>
				</div>

				<div *ngIf="entry.filterTemplates.length !== 0" class="usage-block">
					<span class="using-item__label"
								i18n="@@general.subscription.filterModels">Filter Models</span>
					<div *ngFor="let filterTemplate of entry.filterTemplates" class="consumer-element">
						<!--						<a appNavigate [navigateTo]="colTemplate.elemUrl">{{colTemplate.label}}</a>-->
						<span class="using-item">{{ filterTemplate.label }}</span>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</app-modal>
